module.exports = __webpack_public_path__ + "static/img/6.cf50a7d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/3/zh/6.png
// module id = EEUC
// module chunks = 0